module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('cover-image', {
    attrs: {
      "src": "static/bg-about.jpg",
      "title": _vm.$t('title.contact'),
      "subtitle": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row content"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "row"
  }, [_vm._v("SeConS")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.address')) + ": " + _vm._s(_vm.$t('text.address_secons')))]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.phone')) + ": +381 11 4505 818")]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.fax')) + ": +381 11 4505 831")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h2', {
    staticClass: "row"
  }, [_vm._v("FREN")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.address')) + ": " + _vm._s(_vm.$t('text.address_fren')))]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.phone')) + ": +381 11 3021 069")]), _vm._v(" "), _c('p', {
    staticClass: "row"
  }, [_vm._v(_vm._s(_vm.$t('label.fax')) + ": +381 69 80 421")]), _vm._v(" "), _vm._m(3)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "mailto:office@secons.net"
    }
  }, [_vm._v("office@secons.net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "http://www.secons.net",
      "target": "_blank"
    }
  }, [_vm._v("www.secons.net")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "mailto:office@fren.org.rs"
    }
  }, [_vm._v("office@fren.org.rs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "row"
  }, [_c('a', {
    attrs: {
      "href": "http://www.fren.org.rs",
      "target": "_blank"
    }
  }, [_vm._v("www.fren.org.rs")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b3e2b11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ContactView.vue
// module id = 507
// module chunks = 1